import React from "react";
import { Flex, FlexProps } from "@chakra-ui/react";

export interface ColProps extends FlexProps {}
export function Col(props: ColProps) {
  return <Flex direction="column" {...props} />;
}
